/** Map Supabase auth error messages to localized i18n keys. */
export function authErrorKey(message?: string | null): string {
  const m = (message ?? "").toLowerCase();
  if (!m) return "authErr.generic";
  if (m.includes("invalid login credentials") || m.includes("invalid credentials"))
    return "authErr.invalidCredentials";
  if (m.includes("email not confirmed") || m.includes("not confirmed"))
    return "authErr.emailNotConfirmed";
  if (m.includes("user not found") || m.includes("no user found")) return "authErr.userNotFound";
  if (m.includes("already registered") || m.includes("already exists") || m.includes("already been registered"))
    return "authErr.emailExists";
  if (m.includes("rate limit") || m.includes("too many requests") || m.includes("email rate"))
    return "authErr.rateLimit";
  if (m.includes("password should be") || m.includes("weak password") || m.includes("password is too short"))
    return "authErr.weakPassword";
  if (m.includes("expired") || m.includes("invalid or has expired") || m.includes("otp_expired"))
    return "authErr.expiredLink";
  if (m.includes("invalid email") || m.includes("unable to validate email"))
    return "authErr.invalidEmail";
  if (m.includes("failed to fetch") || m.includes("network")) return "authErr.network";
  if (m.includes("same as the old") || m.includes("should be different"))
    return "authErr.samePassword";
  return "authErr.generic";
}
